import $ from 'jquery';
import { counties } from './counties';
/*
  Dynamically get current wellfare area
*/

$('#wellfare__selection').on( "change", function() {
  const NO_WELLFARE = window?.electionApp?.pllNoWellfare || '';
  const WELLFARE = window?.electionApp?.pllWellfare || '';
   const noCounty = $("#no-county");
    if (noCounty) {
      noCounty.remove();
    }
    // Get right county based on city
    let county = counties[this.value];

    if (county === '-') {
      county = NO_WELLFARE;
    }
    $(".wellfare-result").html(`<span>${WELLFARE}:</span><h2>${county}</h2>`);

    // No county available for certain cities
    if ( !$('#no-county').length && county === '-' ) {
      $("#input_1_52").after(` <span id="no-county"> - ${NO_WELLFARE}</span>`);
    }
});

/*
  Dynamically change wallfare area depending on city
*/
$('#input_1_28').on( "change", function() {
  const NO_WELLFARE = window?.electionApp?.pllNoWellfare || '';
   const noCounty = $("#no-county");
    if (noCounty) {
      noCounty.remove();
    }
    // Get right county based on city
    const county = counties[this.value];

    //  County field
    const countyField = $('#input_1_52');

    // Find right county
    countyField.find('option[value="'+ county +'"]').prop('selected', 'selected');

    // No county available for certain cities
    if ( !$('#no-county').length && county === '-' ) {
      $("#input_1_52").after(` <span id="no-county"> - ${NO_WELLFARE}</span>`);
    }
});
